import CrudModule from "@/components/CrudModule";
import { rupees } from "@/lib/api";
import { Landmark } from "lucide-react";

export default function Accounts() {
    return (
        <CrudModule
            testid="accounts-page"
            eyebrow="Bank, FDs, Loans"
            title="Every account, one quiet ledger."
            subtitle="Savings, FDs, RDs, loans, credit cards. We watch the maturities."
            endpoint="/accounts"
            emptyIcon={Landmark}
            emptyTitle="No accounts yet"
            emptyBody="Add your savings, FDs, RDs, loans and credit cards. We'll surface maturities and dues."
            fields={[
                { key: "account_type", label: "Account type", type: "select", required: true, defaultValue: "savings",
                  options: [
                    { value: "savings", label: "Savings" },
                    { value: "current", label: "Current" },
                    { value: "fd", label: "Fixed Deposit" },
                    { value: "rd", label: "Recurring Deposit" },
                    { value: "loan", label: "Loan" },
                    { value: "credit_card", label: "Credit Card" },
                  ] },
                { key: "bank_name", label: "Bank / Issuer", required: true, placeholder: "HDFC Bank, SBI…" },
                { key: "account_number_last4", label: "Account / Card last 4", placeholder: "1234" },
                { key: "balance", label: "Balance / Outstanding (₹)", type: "number" },
                { key: "interest_rate", label: "Interest rate (%)", type: "number" },
                { key: "maturity_date", label: "Maturity date (FD/RD)", type: "date" },
                { key: "nominee", label: "Nominee" },
                { key: "notes", label: "Notes", type: "textarea" },
            ]}
            columns={[
                { key: "account_type", label: "Type",
                  render: (r) => <span className="capitalize">{(r.account_type || "").replace("_", " ")}</span> },
                { key: "bank_name", label: "Bank" },
                { key: "account_number_last4", label: "Last 4",
                  render: (r) => <span className="font-mono text-xs">{r.account_number_last4 || "—"}</span> },
                { key: "balance", label: "Balance", render: (r) => <span className="font-mono">{rupees(r.balance)}</span> },
                { key: "interest_rate", label: "Rate",
                  render: (r) => r.interest_rate ? `${r.interest_rate}%` : "—" },
                { key: "maturity_date", label: "Matures", render: (r) => r.maturity_date || "—" },
                { key: "nominee", label: "Nominee", render: (r) => r.nominee || "—" },
            ]}
        />
    );
}
